import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tileView", "tableView", "tileToggle", "tableToggle"]

  connect() {
    const saved = localStorage.getItem("win_objective_view_preference")
    if (saved === "table") {
      this.activateTable()
    } else {
      this.activateTile()
    }
  }

  switchToTile(event) {
    if (event) event.preventDefault()
    this.activateTile()
    localStorage.setItem("win_objective_view_preference", "tile")
  }

  switchToTable(event) {
    if (event) event.preventDefault()
    this.activateTable()
    localStorage.setItem("win_objective_view_preference", "table")
  }

  activateTile() {
    if (this.tileViewTargets.length === 0 || this.tableViewTargets.length === 0) return
    this.tileViewTargets.forEach(el => el.classList.remove("hidden"))
    this.tableViewTargets.forEach(el => el.classList.add("hidden"))
    this.updateButtons("tile")
  }

  activateTable() {
    if (this.tileViewTargets.length === 0 || this.tableViewTargets.length === 0) return
    this.tileViewTargets.forEach(el => el.classList.add("hidden"))
    this.tableViewTargets.forEach(el => el.classList.remove("hidden"))
    this.updateButtons("table")
  }

  updateButtons(mode) {
    if (!this.hasTileToggleTarget || !this.hasTableToggleTarget) return
    const activeClasses = ["bg-gray-100", "text-gray-900"]
    const inactiveClasses = ["text-gray-400", "hover:text-gray-600"]

    if (mode === "tile") {
      this.tileToggleTarget.classList.add(...activeClasses)
      this.tileToggleTarget.classList.remove(...inactiveClasses)
      this.tableToggleTarget.classList.remove(...activeClasses)
      this.tableToggleTarget.classList.add(...inactiveClasses)
    } else {
      this.tableToggleTarget.classList.add(...activeClasses)
      this.tableToggleTarget.classList.remove(...inactiveClasses)
      this.tileToggleTarget.classList.remove(...activeClasses)
      this.tileToggleTarget.classList.add(...inactiveClasses)
    }
  }
}
